/**
 * @Author: tom
 * @Date:   2017-11-20T00:03:29+01:00
  @Last modified by:   tom
  @Last modified time: 2019-06-09T22:59:38+02:00
 */

import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'

// to scroll to anchor https://stackoverflow.com/questions/44954856/how-to-simulate-the-scroll-to-anchor-on-page-load-in-vue-router
import VueScrollTo from 'vue-scrollto'

Vue.use(Router)

// scrollBehavior:
// - only available in html5 history mode
// - defaults to no scroll behavior
// - return false to prevent scroll
const scrollBehavior = function (to, from, savedPosition) {
  if (to.hash) {
    // there is a hash in the url, so try to scroll there
    setTimeout(() => VueScrollTo.scrollTo(to.hash, 700), 100)
    // only scroll once an dont jump
    return false
  } else if (savedPosition) {
    // savedPosition is only available for popstate navigations: back/forward.
    return savedPosition
  } else {
    // no hash, then we will go to top
    return { x: 0, y: 0 }
  }
}

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // To allow anchors:
  scrollBehavior,

  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
  routes: [
    // { path: '/index.html', // or '*'
    //   beforeEnter: (to, from, next) => {
    //     next('/')
    //   }
    // },
    {
      path: '/index.html',
      alias: ['/', '/home'],
      name: 'Home',
      component: Home
    },

    // ** puck **
    {
      path: '/puck',
      name: 'puck',
      component: () => import(/* webpackChunkName: "puck" */ '@/components/products/puck/Puck')
    },
    // ** services **
    {
      path: '/consumers',
      name: 'consumer_sol',
      component: () => import(/* webpackChunkName: "blog" */ '@/components/solutions/Consumer')
    },
    {
      path: '/business',
      name: 'business_sol',
      component: () => import(/* webpackChunkName: "business_sol" */ '@/components/solutions/Business')
    },

    // ** prices **
    {
      path: '/puck/preorder',
      name: 'puck_order',
      component: () => import(/* webpackChunkName: "blog" */ '@/components/prices/PuckPreOrder')
    },
    {
      path: '/prices/puck',
      name: 'puck_prices',
      component: () => import(/* webpackChunkName: "puck_prices" */ '@/components/prices/PuckPrices')
    },

    // ** Resources **
    {
      path: '/blog/:nr?',
      name: 'blog',
      component: () => import(/* webpackChunkName: "blog" */ '@/components/resources/Blog')
    },
    {
      path: '/docs',
      name: 'download',
      component: () => import(/* webpackChunkName: "download" */ '@/components/resources/DocDownload')
    },
    {
      path: '/technology',
      name: 'technology',
      component: () => import(/* webpackChunkName: "technology" */ '@/components/resources/Technology')
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import(/* webpackChunkName: "faq" */ '@/components/resources/FAQ')
    },

    // ** about us **
    {
      path: '/aboutus',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ '@/components/aboutus/Aboutus')
    },
    {
      path: '/career',
      name: 'career',
      component: () => import(/* webpackChunkName: "career" */ '@/components/aboutus/Career')
    },
    // { path: '/go/:id',
    //   name: 'QuickScan',
    //   component: GoCampaign
    // },
    // { path: '/refcase/:id',
    //   name: 'Solutions',
    //   component: Solutions
    // },
    /* global VERSION */
    {
      path: '/upgrade',
      alias: '/upgrade_' + VERSION.replace(/\./g, '_'),
      name: 'upgrade',
      component: () => import(/* webpackChunkName: "upgrade" */ '@/components/helpers/Upgrade')
    },
    // { path: '*',
    //   component: () => import(/* webpackChunkName: "notfound" */ '@/components/helpers/NotFound')
    // },
    {
      path: '*', // or '/index.html'
      beforeEnter: (to, from, next) => {
        next('/')
      }
    }
  ]
})
